import React from "react";
import ReactDOM from "react-dom";
import "./sass/index.scss";
import App from "./component/App";

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js